<template>
    <Layout>
        <jps-list 
            :title="title" 
            :subtitle="title" 
            :crumbs="crumbs" 
            :url="url"
            :fields="fields"
            :model="model"
            :user="user" />
    </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import JpsList from "./list";

export default {
    name: 'JpsIndex',
    page: {
        title: 'Joint Plan Section (JPS)',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: {
        Layout,
        'jps-list': JpsList,
    },
    data() {
        return {
            user: this.$store ? this.$store.state.auth.currentUser : {} || {},
            title: 'Joint Plan Section (JPS)',
            crumbs: [
                {
                    text: 'Joint Plan Section (JPS)',
                    href: '/jps',
                }
            ],
            url: '/web/transaksi/jps',
            fields: [
                {
                    key: 'pekerjaan',
                    label: 'Pekerjaan',
                    sortable: true,
                },
                {
                    key: 'witel',
                    label: 'Witel',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return (value && value.nama) || '-';
                    }
                },
                {
                    key: 'pelanggan',
                    label: 'Pelanggan',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return value.nama || '-';
                    }
                },
                {
                    key: 'nilai_revenue',
                    label: 'Nilai Revenue',
                    sortable: true,
                    formatter: (value, key, item) => {
                        let val = (value / 1).toFixed(2).replace('.', ',')
                        return 'Rp ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    },
                },
                {
                    key: 'nilai_pengeluaran',
                    label: 'Nilai Pengeluaran',
                    sortable: true,
                    formatter: (value, key, item) => {
                        let val = (value / 1).toFixed(2).replace('.', ',')
                        return 'Rp ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    },
                },
                {
                    key: 'margin',
                    label: 'Margin',
                    sortable: true,
                    formatter: (value, key, item) => {
                        let val = (value / 1).toFixed(2).replace('.', ',')
                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '%'
                    },
                },
                {
                    key: 'mekanisme_pembayaran',
                    label: 'Top',
                    sortable: true,
                },
                {
                    key: 'jaminan_pekerjaan',
                    label: 'Jaminan Pekerjaan',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return value || '-';
                    }
                },
                {
                    key: 'list_garansi',
                    label: 'List Garansi',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return value ? 'Ya' : 'Tidak';
                    }
                },
                {
                    key: 'jenis_proyek',
                    label: 'Skema Project',
                    sortable: true,
                },
                {
                    key: 'status_kabid_kemitraan',
                    label: 'Status Kabid Kemitraan',
                    sortable: true,
                },
                {
                    key: 'status_sekretaris',
                    label: 'Status Sekretaris',
                    sortable: true,
                },
                {
                    key: 'status_ketua',
                    label: 'Status Ketua',
                    sortable: true,
                },
                { 
                    key: 'id', 
                    label: 'Aksi', 
                    sortable: false, 
                },
            ],
            model: {
                id: '',
                nama: '',
                status: 'AKTIF',
            },
        }
    },
}
</script>

<style>

</style>